import { createConfig, http, fallback } from "wagmi";
import { injected } from "wagmi/connectors";

export const ethChain = {
  id: 1,
  name: "Ethereum",
  network: "ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: { default: { http: [process.env.REACT_APP_RPC_ETH] } },
  blockExplorers: { default: { name: "Etherscan", url: "https://etherscan.io" } },
};

export const bscChain = {
  id: 56,
  name: "BNB Smart Chain",
  network: "bsc",
  nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
  rpcUrls: { default: { http: [process.env.REACT_APP_RPC_BSC] } },
  blockExplorers: { default: { name: "BSCScan", url: "https://bscscan.com" } },
};

export const bescChain = {
  id: 2372,
  name: "BESC HyperChain",
  network: "besc",
  nativeCurrency: { name: "BESC", symbol: "BESC", decimals: 18 },
  rpcUrls: { default: { http: ["https://hyper.beschyperchain.com", "https://rpc.beschyperchain.com"] } },
  blockExplorers: { default: { name: "BESC Explorer", url: "https://explorer.beschyperchain.com" } },
};

export const robinhoodChain = {
  id: 4663,
  name: "Robinhood Chain",
  network: "robinhood",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: { default: { http: [process.env.REACT_APP_RPC_RH || "https://rpc.mainnet.chain.robinhood.com"] } },
  blockExplorers: { default: { name: "Robinhood Explorer", url: "https://robinhoodchain.blockscout.com" } },
};

export const injectedConnector = injected({
  shimDisconnect: true,
});

export const wagmiConfig = createConfig({
  chains: [ethChain, bscChain, bescChain, robinhoodChain],
  connectors: [injectedConnector],
  transports: {
    [ethChain.id]: http(process.env.REACT_APP_RPC_ETH),
    [bscChain.id]: http(process.env.REACT_APP_RPC_BSC),
    [bescChain.id]: fallback([
      http("https://hyper.beschyperchain.com", { timeout: 10000 }),
      http("https://rpc.beschyperchain.com", { timeout: 10000 }),
    ]),
    [robinhoodChain.id]: http(process.env.REACT_APP_RPC_RH || "https://rpc.mainnet.chain.robinhood.com"),
  },
});
